import config from '../config.json'
 
const isEncryptionEnabled = process.env.REACT_APP_IS_ENCRYPTION_ENABLED;
 
const demo = config.DEMO;
const uatBaseURL = isEncryptionEnabled === "true" ? "https://aointakeuatapi-apim.azure-api.net/LPL" : "https://aointakeuatapi.agingoptions.com";
const prodBaseURL = isEncryptionEnabled ==="true" ? "https://aointakeapi-apim.azure-api.net/LPL" : "https://aointakeapi-hcfhhdfmhfgtctdd.westus2-01.azurewebsites.net";
 
// export const BASE_URL = (demo) ? "https://aointakeuatapi.agingoptions.com" : "https://aointakeapi-hcfhhdfmhfgtctdd.westus2-01.azurewebsites.net";
 
 
export const BASE_URL = (demo)? uatBaseURL : prodBaseURL;
export const AoLoginBaseUrl = (demo) ? "https://aologinuat.agingoptions.com/" : "https://Unilogin.agingoptions.com/";
export const AoIntakeBaseUrl = (demo) ? "https://aointakeformuat.agingoptions.com/" : "https://member.intake.agingoptions.com/";
export const EventBaseUrl = (demo) ? "https://eventuat.agingoptions.com/" : "https://events.agingoptions.com/";
export const CounterBaseUrl = (demo) ? "https://aoeventcounteruat.agingoptions.com/" : "https://Event.counter.agingoptions.com/";
export const CounterMobileBaseUrl = (demo) ? "https://aoeventcountermobileuat.agingoptions.com/" : "https://event.mcounter.agingoptions.com/";
export const AoAdminBaseUrl = (demo) ? 'https://Aoadminuat.agingoptions.com/' : 'https://AOAdmin.agingoptions.com/';;
export const AoPartnerBaseUrl = (demo) ? "https://aopartneruat.agingoptions.com/" : "https://partner.admin.agingoptions.com/";;
export const IntakeEntryBaseUrl = (demo) ? "https://intakeentryformuat.azurewebsites.net/" : "https://intakeentryform.azurewebsites.net/";
export const AoAgentBaseUrl = (demo) ? 'https://aoagentuat.agingoptions.com/' : 'https://agent.agingoptions.com/';
// export const AoAcaddemyUrl = (demo) ? "https://agingoptionsacademy.com/" : "https://agingoptionsacademy.com/"
export const AoPaymentUrl = (demo) ? 'https://aopaymentdev.agingoptions.com/' : "https://aopayment.azurewebsites.net/";


// export const stripePaymentLink=(demo)?'https://buy.stripe.com/test_14k5l31QAbCC5JC8wA':'https://buy.stripe.com/4gw17c5bfcRzaGYbIP'
export const stripePaymentLink=(demo)?'https://buy.stripe.com/test_14k5l31QAbCC5JC8wA':'https://buy.stripe.com/00g038avzg3LaGYdR0'
// -------------------

// export const AoAcaddemyUrl = (demo) ? "https://academy.nsplindia.co.in" : "https://agingoptionsacademy.com/"
export const AoAcaddemyUrl = (demo) ? "https://lpl.nsplindia.co.in/" : "https://agingoptionsacademy.com/";
export const onDemandUrl = (demo) ? "https://ondemand.nsplindia.co.in" : "https://portal.agingoptions.com/";
export const stripePaymentConfirmationUrl=(demo) ?'https://academy.nsplindia.co.in//wp-json/custom-api/v1/update-user-confirmation':'https://agingoptionsacademy.com/wp-json/custom-api/v1/update-user-confirmation'

// -------------------  
const AoUrl = {
    getAthenticatePath: '/api/2/User/AuthenticateLoggedInUser/',
    getSubtenantDetailPath: 'api/Subtenant/get-subtenant-details',
    createAcademyUser: BASE_URL + '/api/User/CreateAcademyUser',
    getExpirydatetime: BASE_URL + '/api/UserValidity/GetUserValidity',
    postAddUserOrder:'/api/UserOrder/AddUserOrder',// 
    upGradeValidity : '/api/UserValidity/UpgradeUserValidity',
    postLogUserout: BASE_URL + '/api/User/LogoutUser/'
}


export default AoUrl;
